(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/lyckoplatsen/assets/javascripts/import-module-component.js') >= 0) return;  svs.modules.push('/modules/lyckoplatsen/assets/javascripts/import-module-component.js');

'use strict';

const toNamespace = str => {
  var _str$replaceAll, _str$replaceAll2;
  return (_str$replaceAll = str === null || str === void 0 || (_str$replaceAll2 = str.replaceAll) === null || _str$replaceAll2 === void 0 ? void 0 : _str$replaceAll2.call(str, '-', '_')) !== null && _str$replaceAll !== void 0 ? _str$replaceAll : str;
};

const importModuleComponent = (moduleComponent, pageName) => () => {
  const componentNamespace = toNamespace(moduleComponent);
  return new Promise(resolve => {
    var _svs$lyckoplatsen$com;
    if ((_svs$lyckoplatsen$com = svs.lyckoplatsen.components) !== null && _svs$lyckoplatsen$com !== void 0 && _svs$lyckoplatsen$com[componentNamespace]) {
      resolve({
        default: svs.lyckoplatsen.components[componentNamespace].react[pageName]
      });
      return;
    }
    svs.core.module.loadModuleComponent(moduleComponent, () => {
      resolve({
        default: svs.lyckoplatsen.components[componentNamespace].react[pageName]
      });
    });
  });
};
Object.assign(svs.lyckoplatsen, {
  importModuleComponent
});

 })(window);